import { Field, FieldEntry } from 'scripts/type'
import calcIsConditionGroupMatched from './calcIsConditionGroupMatched'

function findTriggeredFields(fields: Field[], code: string, value: any) {
  const showRules = fields.find((field) => field.code === code)?.showRules || []
  if (showRules.length) {
    const triggeredCodes = showRules.reduce((preData, { targets, conditionGroup }) => {
      if (conditionGroup && calcIsConditionGroupMatched(conditionGroup, value)) {
        return preData.concat(targets)
      }
      return preData
    }, [] as any[])
    return fields.filter((field) => triggeredCodes.includes(field.code))
  }
  return null
}

export default function findAllTriggeredFields(fieldEntries: FieldEntry[], fields: Field[], code: string, value: any) {
  const triggeredFields = findTriggeredFields(fields, code, value)
  let allTriggeredFields = triggeredFields || []
  triggeredFields?.forEach((field) => {
    const entry = fieldEntries.find((entry) => entry.code === field.code)
    if (entry) {
      const childTriggeredFields = findAllTriggeredFields(fieldEntries, fields, entry.code, entry.value)
      allTriggeredFields = allTriggeredFields.concat(childTriggeredFields || [])
    }
  })
  return allTriggeredFields
}
